import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=2b7fcb32&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"
import style0 from "./Branches.vue?vue&type=style&index=0&id=2b7fcb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fcb32",
  null
  
)

export default component.exports